module.exports = __webpack_public_path__ + "img/service-screen-plot.7b192e0e.png";